import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch 
} from 'react-router-dom';
import Home from './pages/home';
import Regulations from './pages/regulation';
import FAQ from './pages/faq';
import { URLProvider } from './contexts/URLContext';

const App = () => {
  return(
    <Router>
      <Switch>
        <URLProvider>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/regulamento">
            <Regulations />
          </Route>
          <Route path="/faq">
            <FAQ />
          </Route>
        </URLProvider>
      </Switch>
    </Router>
  );
};

export default App;